import UIFlex from 'UIComponents/layout/UIFlex';
import { Big } from 'foundations-components/transitional/components/Big';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReadabilityIssueCategories } from '../constants';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IssueCategorySubHeader = ({
  category
}) => {
  switch (category) {
    case ReadabilityIssueCategories.GRAMMAR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.readabilityRecs.categories.GRAMMAR"
      });
    default:
      console.error(`No readability category translation found for ${category}`);
      return null;
  }
};
export const ReadabilityIssuesCardList = ({
  issues
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "m-left-6 m-bottom-2",
    children: issues.map((issue, index) => {
      const {
        category,
        text,
        suggestions
      } = issue;
      if (suggestions.length === 0) {
        return null;
      }
      return /*#__PURE__*/_jsx(View, {
        borderColor: "do-not-use-button-tertiary-light-hover-fill",
        borderWidth: "100",
        borderStyle: "solid",
        paddingBlock: "250",
        paddingInline: "500",
        marginBlock: "100",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          direction: "row",
          align: "baseline",
          children: [/*#__PURE__*/_jsx(View, {
            textAlign: "center",
            marginInlineEnd: "250",
            children: /*#__PURE__*/_jsx(Big, {
              weight: "medium",
              color: "do-not-use-linkedin",
              children: "\u2022"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginInlineEnd: "250",
            children: /*#__PURE__*/_jsx("strong", {
              children: text
            })
          }), /*#__PURE__*/_jsxs("span", {
            children: [/*#__PURE__*/_jsx(IssueCategorySubHeader, {
              category: category
            }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.recommendations.readabilityRecs.errorText"
            })]
          })]
        })
      }, index);
    })
  });
};